export default __webpack_public_path__ + "static/media/logo_bilbao_firma.311ebcd8.png";